import {
  ResizableHorizontalChildren,
  ResizeMouseEventHandler,
  State,
} from './types';
import { updateConfigs } from './utils';
import { reduceIsCollapsed } from './reduceIsCollapsed';

type ReduceIsCollapsedAllChildrenArgs = {
  children: ResizableHorizontalChildren;
  containerRef: React.RefObject<HTMLDivElement | null>;
  onResizeEnd?: ResizeMouseEventHandler;
  getValueFromDOMRect: (rect: DOMRect) => number;
};

export const reduceIsCollapsedAllChildren = (
  state: State,
  {
    children,
    containerRef,
    onResizeEnd,
    getValueFromDOMRect,
  }: ReduceIsCollapsedAllChildrenArgs
) => {
  if (
    children.every(
      ({ props: { isCollapsed } }, index) =>
        typeof isCollapsed !== 'boolean' ||
        (state.isStyleInitialized &&
          state.configs[index].isCollapsed === isCollapsed)
    )
  ) {
    // No render update triggered.
    return state;
  }

  return children.reduce(
    (state, { props: { isCollapsed } }, index) => {
      if (typeof isCollapsed !== 'boolean') return state;
      // If some section are set initially to be collapsed, reducing the
      // collapsed values to the open section would not work properly
      // because the style is not initialized yet. Skipping reducing
      // will just set the collapsed state properly, but other than that
      // set the values to the initial values.
      const skipReducing = !state.isStyleInitialized;

      return state.isStyleInitialized &&
        state.configs[index].isCollapsed === isCollapsed
        ? state
        : reduceIsCollapsed(state, index, isCollapsed, skipReducing);
    },
    {
      ...updateConfigs(state, containerRef.current, getValueFromDOMRect),
      isResizeEndScheduled: Boolean(onResizeEnd),
    }
  );
};
